export enum WidgetLoaderDataHooks {
  ROOT = 'widget-loader',
  SPINNER = 'widget-loader-spinner',
}
